import { render, staticRenderFns } from "./OResetPassComp.vue?vue&type=template&id=5a566613&scoped=true&"
import script from "./OResetPassComp.vue?vue&type=script&lang=ts&"
export * from "./OResetPassComp.vue?vue&type=script&lang=ts&"
import style0 from "./OResetPassComp.vue?vue&type=style&index=0&id=5a566613&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a566613",
  null
  
)

export default component.exports